/* 报销接口 */
import { $post, $download } from '@/api/request'

// 列表查询
export function queryMine (data = {}) {
  return $post({
    url: '/compApplyReimbursement/queryMine',
    data
  })
}
// 报销申请详情
export function getApplyDetail (data = {}) {
  return $post({
    url: '/compApplyReimbursement/getApplyDetail',
    data
  })
}
// 发起报销申请
export function submitApply (data = {}) {
  return $post({
    url: '/compApplyReimbursement/submitApply',
    data
  })
}
// 审批报销申请
export function audit (data = {}) {
  return $post({
    url: '/compApplyReimbursement/audit',
    data
  })
}
// 审批报销申请
export function auditAndNextUser (data = {}) {
  return $post({
    url: '/compApplyReimbursement/auditAndNextUser',
    data
  })
}
// 查询所有人的报销申请 compApplyReimbursement/query
export function query (data = {}) {
  return $post({
    url: '/compApplyReimbursement/query',
    data
  })
}
// 报销导出
export function compApplyReimbursementExport (data = {}) {
  return $download({
    url: '/compApplyReimbursement/export',
    data
  })
}
// 查询待我审批的 
export function queryWaitMeProcess (data = {}) {
  return $post({
    url: '/compApplyReimbursement/queryWaitMeProcess',
    data
  })
}
// 查询已审批的 
export function listApplyAudited (data = {}) {
  return $post({
    url: '/compApplyReimbursement/listApplyAudited',
    data
  })
}
// 暂存审批
export function stagingApply (data = {}) {
  return $post({
    url: '/compApplyReimbursement/stagingApply',
    data
  })
}
// 催批
export function sendSmsAuditPersonAgain (data = {}) {
  return $post({
    url: '/compApplyReimbursement/sendSmsAuditPersonAgain',
    data
  })
}
// 催批
export function update (data = {}) {
  return $post({
    url: '/compApplyReimbursement/update',
    data
  })
}
// 已付款通知 
export function payedNotify (data = {}) {
  return $post({
    url: '/compApplyReimbursement/payedNotify',
    data
  })
}